import { ManagePointOfContactRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateManagePointOfContact = makeValidator({
  FieldParser: ManagePointOfContactRow,
});
